import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React, { ElementType, useMemo } from 'react';
import { Badge, BadgeProps } from '../../layout/Badge';

/**
 * @typedef {object} IconProps
 * @property {any} glyph svg component to render
 */

export interface IconProps extends SvgIconProps {
  glyph: ElementType<any>;
  badgeProps?: BadgeProps;
  dataCy?: string;
}

/**Used for SVG Icons (wraps the MUI SvgIcon component) */
export function Icon({ glyph, badgeProps, dataCy, ...otherProps }: IconProps) {
  const viewBox = useMemo(() => {
    try {
      if (typeof glyph !== 'function') return undefined;
      const result = (glyph as Function)({});
      return result?.props?.viewBox;
    } catch {
      return undefined;
    }
  }, [glyph]);
  const { badgeContent, ...otherBadgeProps } = badgeProps || {};

  if (
    badgeContent === undefined ||
    badgeContent === null ||
    badgeContent === ''
  ) {
    return (
      <SvgIcon
        data-cy={dataCy ? dataCy : 'icon'}
        {...otherProps}
        component={glyph}
        viewBox={viewBox}
      />
    );
  }

  return (
    <Badge
      sx={{
        '.MuiBadge-badge': {
          fontSize: '0.75rem',
          minWidth: '1rem',
          height: '1rem',
          transform: 'scale(1) translate(50%, -65%)'
        }
      }}
      badgeContent={badgeContent}
      data-cy="icon"
      {...otherBadgeProps}
    >
      <SvgIcon {...otherProps} component={glyph} viewBox={viewBox} />
    </Badge>
  );
}
